import { useEffect } from "react";

import { useBreadcrumbsContext } from "../context";

import type { BreadcrumbItem } from "../models";

export interface UseBreadcrumbsParams {
  breadcrumbs: BreadcrumbItem[];
}

export function useBreadcrumbs({ breadcrumbs }: UseBreadcrumbsParams) {
  const { setBreadcrumbs } = useBreadcrumbsContext();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);

    return () => {
      setBreadcrumbs([]);
    };
  }, [breadcrumbs, setBreadcrumbs]);
}
